import clsx from "clsx";
import { Children, useLayoutEffect, useRef, useState } from "react";
import type { ChildrenProps, ClassNameProps } from "../types";

/** Props Interface */
interface AutoScrollContainerProps extends ChildrenProps, ClassNameProps {}

export function AutoScrollContainer({ children, className }: AutoScrollContainerProps) {
	/** Hooks */
	const scrollRef = useRef<HTMLDivElement>(null);
	const [isInitiallyScrolled, setIsInitiallyScrolled] = useState<boolean>(false);

	/** Effects */
	useLayoutEffect(() => {
		if (Children.toArray(children).length === 0) return;
		if (isInitiallyScrolled) return;
		const node = scrollRef.current;
		if (node) {
			node.scrollTop = node.scrollHeight;
			setIsInitiallyScrolled(true);
		}
	}, [children, isInitiallyScrolled]);

	/** Render */
	return (
		<div
			ref={scrollRef}
			className={clsx(className)}
		>
			{children}
		</div>
	);
}
